/**
 * Strips carriage returns, line feeds, and tabs from the string representation
 * of a value before it is written to a log, preventing log-injection attacks (CWE-117).
 */
export function sanitizeForLog(value: unknown): string {
    return String(value).replace(/[\r\n\t]/g, " ");
}
